import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import _get from 'lodash/get';

function itemListToMapId(itemList) {
  return itemList.reduce(function (itemMap, item) {
    return _objectSpread(_objectSpread({}, itemMap), {}, _defineProperty({}, item._id, item));
  }, {});
}

export default (function (payload) {
  var menu = _get(payload, 'fishermanBusiness.menu');

  if (menu) {
    // Check if menu is a URL (string)
    if (typeof menu === 'string') {
      return menu;
    }

    var categories = itemListToMapId(menu.categories);
    var items = itemListToMapId(menu.items);
    var modifierSets = itemListToMapId(menu.modifierSets);
    var modifiers = itemListToMapId(menu.modifiers);
    return {
      '@type': 'Menu',
      // One section per schedule
      hasMenuSection: menu.schedules.map(function (schedule) {
        return {
          '@type': 'MenuSection',
          name: schedule.name,
          // TODO: discuss and define how schedule times should be set
          // offers: {
          //   "@type": "Offer",
          //   availabilityEnds: "T8:22:00",
          //   availabilityStarts: "T8:22:00"
          // },
          // One sub-section per menu category
          hasMenuSection: schedule.categories.map(function (categoryId) {
            var category = categories[categoryId];
            return {
              '@type': 'MenuSection',
              name: category.name,
              hasMenuItem: category.items.map(function (itemId) {
                var item = items[itemId];
                return {
                  '@type': 'MenuItem',
                  name: item.name,
                  description: item.description,
                  offers: item.variations.map(function (variation) {
                    return {
                      '@type': 'Offer',
                      name: variation.name,
                      price: variation.price,
                      priceCurrency: 'USD'
                    };
                  }),
                  menuAddOn: item.modifierSets.reduce(function (menuAddOnList, modifierSetId) {
                    var modifierSet = modifierSets[modifierSetId];
                    var menuAddOnInSet = modifierSet.modifiers.map(function (modifierId) {
                      var modifier = modifiers[modifierId];
                      return {
                        '@type': 'MenuItem',
                        name: modifier.name,
                        description: modifierSet.name,
                        offers: {
                          '@type': 'Offer',
                          price: modifier.price,
                          priceCurrency: 'USD'
                        }
                      };
                    });
                    return menuAddOnList.concat(menuAddOnInSet);
                  }, [])
                };
              })
            };
          })
        };
      })
    };
  }

  return undefined;
});